import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubPortfolioRisksComponent } from './sub-portfolio-risks.component';


const routes: Routes = [
  {
    path: '',
    component: SubPortfolioRisksComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubPortfolioRisksRoutingModule { }
